module.exports = __webpack_public_path__ + "static/media/completed-powerful-punch.1e37dd42.png";